import { Avatar, Button, Paper, styled } from '@mui/material';
import DefaultCloseButton from 'components/CloseButton';
import MediaTypography from 'components/MediaTypography';

export const Wrap = styled('li', {
	shouldForwardProp: (prop: string) => !['isImportant', 'isReaded'].includes(prop),
})<{ isImportant: boolean; isReaded: boolean }>(({ theme, isImportant, isReaded }) => ({
	background: '#FAFCFD',
	boxShadow: '0px 0px 30px 0px rgba(130, 125, 131, 0.15)',
	borderRadius: '16px',
	padding: '8px',
	display: 'flex',
	flexDirection: 'column',
	gap: '8px',
	[theme.breakpoints.down('sm')]: {
		borderRadius: '12px',
	},

	...(isImportant && {
		border: '2px solid',
		borderColor: theme.palette.error.contrastText,
		marginTop: '16px',
		position: 'relative',
		transformStyle: 'preserve-3d',
	}),

	...(isReaded && {
		filter: 'brightness(0.95)',
		opacity: 0.7,
	}),
}));

export const Header = styled('div')(({ theme }) => ({
	display: 'flex',
	gap: '8px',
	alignItems: 'center',

	[theme.breakpoints.down('sm')]: {
		'& .MuiAvatar-root': {
			width: '40px',
			height: '40px',
		},
	},
}));

export const UserAvatar = styled(Avatar)(({ theme }) => ({
	width: '48px',
	height: '48px',

	[theme.breakpoints.down('sm')]: {
		width: '40px',
		height: '40px',
	},
}));

// export const ItemLink = styled(Link, {
// 	shouldForwardProp: (prop) => prop !== 'is_readed',
// })(({ theme, is_readed }: { theme: Theme; is_readed: boolean }) => ({
// 	textDecoration: 'underline',
// 	color: is_readed ? theme.palette.text.disabled : theme.palette.primary.dark,
// 	fontWeight: 600,
// 	fontSize: '12px',
// }));

export const Main = styled(Paper)({
	padding: '8px',
	borderRadius: '12px',
});

export const DateWrap = styled('div')({
	display: 'flex',
	alignItems: 'center',
	gap: '8px',
	justifyContent: 'space-between',
});

export const ConfirmButton = styled(Button)({
	display: 'flex',
	alignItems: 'center',
	gap: '10px',
	justifyContent: 'center',
	width: '100%',
	height: 'auto',
});

export const CloseButton = styled(DefaultCloseButton)({
	marginLeft: 'auto',
	alignSelf: 'flex-start',
	backgroundColor: '#fff',
	borderRadius: '50%',
});

export const StyledMediaTypography = styled(MediaTypography)(({ theme }) => ({
	a: {
		letterSpacing: '0.1px',
		color: '#025FBB',
		fontWeight: 600,
		textDecoration: 'underline',
		'&:hover': {
			textDecoration: 'none',
			color: theme.palette.primary.main,
		},
	},
}));
